import React, { useEffect } from "react"
import { Helmet } from "react-helmet"
import { Link, withPrefix } from "gatsby"
import { Router } from "@reach/router"
import "./../styles/css/bootstrap.css"
import "./../styles/css/font-awesome.min.css"
import "./../styles/css/owl.carousel.css"
import "./../styles/css/style.css"
import "./../styles/css/main.css"
import "./../styles/css/rangeslider.min.css"
import "./../styles/css/bootstrap-datepicker.css"
import "./../styles/css/new-structure.css"
import "../scripts/js/validate/bootstrap-datepicker3.css"
import "../styles/css/flag.css"
import "../scripts/js/validate/select2.min.css"
import "../styles/css/variable.css"
import * as lookup from "../../static/lookup.json"

import { refreshToken } from "../interceptors/jwt-interceptor"
import Layout from "../components/pages/layout"
import Loader1 from "../interceptors/loader-interceptor"
import { JourneyProvider } from "../components/context/journeyContext"
import { LoaderProvider } from "../components/context/loaderContext"
import { getIpAddress, getJWTTokenForIp } from "../services/apiservice"
import * as jounrneyJSON from "../../static/journeyssr.json"
import { isIE } from 'react-device-detect';

export default function Home(props) {
  console.log(props, "abc");
  // useEffect(() => {
  //   getIpAddress()
  //   .then(res => {
  //     let payload = {
  //       ip: res.IPv4
  //     }
  //     if(!refreshToken){
  //       getJWTTokenForIp(payload)
  //     }
  //   })
  //   .catch(err => {
  //     console.log(err)
  //   })
  // }, [])
  console.log(props, "sapp")
  const isBrowser = () => typeof window !== "undefined"
  const windowClosefunction = () => {
    //   if (+window.localStorage.tabCount > 0)
    //     { 
    //         window.alert('Already open!')
    //         window.open(`${process.env.GATSBY_URL}/SameLinkPage`, "_self")
    //         window.close()
    //     }
    //     else
    //     window.localStorage.tabCount = 0

    //     window.localStorage.tabCount = +window.localStorage.tabCount + 1
    //     window.onunload = function () {
    //         localStorage.tabCount = +window.localStorage.tabCount - 1
    //     };
    window.localStorage.openpages = Date.now()
    window.addEventListener("storage",function (e) {
        if (e.key == "openpages") {
          // Listen if anybody else is opening the same page!
          window.localStorage.page_available = Date.now()
        }
        if (e.key == "page_available") {
          if(isIE)
          {
            console.log("Confirm IE")
          }
          else
          {
            window.alert(" Already you have same application running in another window/browser. Please close this window.")
            const productKey = lookup?.urlLookup?.[jounrneyJSON.data.products[0].journeys[0].journeyId]
            if(`${process.env.DEVELOPMENT}` === "Y"){ 
            window.open(`${process.env.GATSBY_URL}/SameLinkPage`, "_self")
            }
            else if(`${process.env.DEVELOPMENT}` === "N"){ 
              window.open(`${process.env.GATSBY_URL}/${productKey}/SameLinkPage`, "_self")
              }
            window.close();
          }
          
        }
      },
      false
    )
  }
  isBrowser() && windowClosefunction()
  return (
    <LoaderProvider>
      <>
      <Helmet>
        <title>
          {lookup["pageTitle"][jounrneyJSON.data.products[0].planId]}
        </title>
      </Helmet>
      <Loader1 />
      <JourneyProvider>
        <Router>
          {!props?.location?.state ? (
            <>
              <Layout path="/" />
              <Layout path="/:id" />
            </>
          ) : props?.location?.state?.applicationData &&
            props?.location?.state?.journeyData ? (
            <>
              <Layout resumeJourneyData={props?.location?.state} path="/" />
              <Layout resumeJourneyData={props?.location?.state} path="/:id" />
            </>
          ) : props?.location?.state?.payloadJson &&
            props?.location?.state?.decryptData ? (
              <>
                <Layout paymentData={props?.location?.state} path="/" />
                <Layout paymentData={props?.location?.state} path="/:id" />
              </>
          ) : props?.location?.state?.enachPayloadJson &&
            props?.location?.state?.enachDecryptData ? (
              <>
                <Layout enachData={props?.location?.state} path="/" />
                <Layout enachData={props?.location?.state} path="/:id" />
              </>
                     ) : props?.location?.state?.lienDecryptData &&
                     props?.location?.state?.lienDecryptData ? (
                       <>
                         <Layout lienData={props?.location?.state} path="/" />
                         <Layout lienData={props?.location?.state} path="/:id" />
                       </>
                     ) : props?.location?.state?.digilockerPayloadJson &&
                     props?.location?.state?.digilockerDecryptData ? (
                     <>
                       <Layout digilockerdata={props?.location?.state} path="/" />
                       <Layout digilockerdata={props?.location?.state} path="/:id" />
                     </>
          ) : props?.location?.state?.fnaData ? (
            <>
                <Layout fnaData={props?.location?.state} path="/" />
                <Layout fnaData={props?.location?.state} path="/:id" />
            </>
          ) : props?.location?.state?.canaraPosData && (
            <>
                <Layout canaraPosData={props?.location?.state} path="/" />
                <Layout canaraPosData={props?.location?.state} path="/:id" />
            </>
          )}
        </Router>
      </JourneyProvider>
      </>
    </LoaderProvider>
  )
}
